// src/components/PlanSelector.tsx

import { useState } from 'react';
import { api } from '../services/api';

const PLANS = [
  {
    id: 1,
    name: 'Free',
    price: 0,
    dms_per_day: 1,
    features: ['First message only', 'Basic support'],
  },
  {
    id: 2,
    name: 'Professional',
    price: 9.99,
    dms_per_day: 100,
    features: ['100 DMs per day', 'Analytics', '7-day history', 'AI enhancement'],
  },
  {
    id: 3,
    name: 'Business',
    price: 29.99,
    dms_per_day: 500,
    features: ['500 DMs per day', 'Advanced analytics', '90-day history', 'API access', 'Priority support'],
  },
];

export function PlanSelector() {
  const [loading, setLoading] = useState<string | null>(null);

  const handleUpgrade = async (planId: number) => {
    try {
      setLoading(String(planId));
      const result = await api.upgradeSubscription(planId);
      
      // Handle free plan (no Stripe needed)
      if (result.success) {
        alert('Plan updated successfully!');
        window.location.reload();
        return;
      }
      
      // Handle Stripe checkout
      if (result.sessionUrl) {
        window.location.href = result.sessionUrl;
      } else if (result.error) {
        // Don't show technical errors to users
        if (result.error.includes('not available') || result.error.includes('contact support')) {
          alert(result.error);
        } else {
          alert('Unable to process payment at this time. Please try again later or contact support.');
        }
      }
    } catch (error: any) {
      // Don't expose technical errors
      const errorMessage = error.response?.data?.error || error.message;
      if (errorMessage?.includes('not available') || errorMessage?.includes('contact support')) {
        alert(errorMessage);
      } else {
        alert('Unable to process payment at this time. Please try again later or contact support.');
      }
    } finally {
      setLoading(null);
    }
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
      {PLANS.map((plan) => (
        <div
          key={plan.id}
          className="bg-white p-6 rounded-lg shadow border-2 border-gray-200"
        >
          <h3 className="text-xl font-bold mb-2">{plan.name}</h3>
          <div className="text-3xl font-bold mb-4">
            ${plan.price}
            <span className="text-sm font-normal text-gray-500">/month</span>
          </div>
          <ul className="space-y-2 mb-6">
            {plan.features.map((feature, idx) => (
              <li key={idx} className="flex items-start">
                <span className="text-green-500 mr-2">✓</span>
                <span className="text-sm">{feature}</span>
              </li>
            ))}
          </ul>
          <button
            onClick={() => handleUpgrade(plan.id)}
            disabled={loading === String(plan.id)}
            className="w-full px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 disabled:opacity-50"
          >
            {loading === String(plan.id) ? 'Processing...' : plan.price === 0 ? 'Current Plan' : 'Upgrade'}
          </button>
        </div>
      ))}
    </div>
  );
}
